module.exports = __webpack_public_path__ + "img/Group-8796.45b2d868.svg";